import SkeletonBox from "@Components/SkeletonBox/SkeletonBox";
import { ActionSkeleton, DetailsCardSkeleton, ExchangeDetailsSkeleton } from "./PointsExchangeSkeleton.shared";

export default function PointsExchangeSkeletonMob() {
  return (
    <div className="flex w-full flex-col gap-4 pb-40">
      <div className="rounded-xs outline-border-subtle flex flex-col gap-6 p-4 outline">
        <DetailsCardSkeleton />
        <ExchangeDetailsSkeleton />
      </div>
      <div className="outline-border-subtle flex w-full items-center gap-3 rounded-xl p-4 outline">
        <SkeletonBox className="size-10 shrink-0 rounded-full" />
        <div className="flex-1">
          <SkeletonBox className="h-4 w-36" />
        </div>
        <SkeletonBox className="size-5 shrink-0" />
      </div>
      <div className="shadow-bottom-sheet bg-background-default fixed end-0 start-0 bottom-0 z-50 rounded-t-xl p-4">
        <ActionSkeleton />
      </div>
    </div>
  );
}
